export const SORT_ORDER = {
  ASCENDING: 1,
  DESCENDING: -1,
  NOT_SORTED: null,
};
